import CryptoJS from 'crypto-js'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import moment from 'moment'
import jwt_decode from 'jwt-decode'
import { notification } from 'antd'
// eslint-disable-next-line
let secretKey = process.env.REACT_APP_DATA_DECRYPTION_KEY.toString()

export const decrypt = (cipher) => {
  var bytes = CryptoJS.AES.decrypt(cipher, secretKey)
  var originalText = bytes.toString(CryptoJS.enc.Utf8)
  return JSON.parse(originalText)
}

export const encrypt = (data) => {
  var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString()
  return ciphertext
}

export const getMode = () => {
  const mode = localStorage.getItem('customer-mode')
  return mode
}
export const getToken = () => {
  const token = localStorage.getItem('token')
  return token
}
export const getAnomaliesCheck = () => {
  const anomaliesCheck = localStorage.getItem('global-anomalies')
  return anomaliesCheck
}

export const GeneratePdf = (singleData, campaignDetails, shopWise) => {
  var doc = new jsPDF()

  doc.text(10, 20, 'Campaign Name : ')
  doc.text(60, 20, singleData?.CampaignName)
  doc.line(10, 25, 250, 25)
  doc.line(10, 26, 250, 26)

  doc.text(10, 45, 'Start Date : ')
  doc.text(75, 45, moment(singleData?.start).format('MMMM Do YYYY'))
  doc.text(10, 55, 'End Date : ')
  doc.text(75, 55, moment(singleData?.end).format('MMMM Do YYYY'))

  doc.text(10, 75, 'Campaign Stats')

  doc.line(10, 80, 250, 80)
  doc.line(10, 82, 250, 82)
  doc.text(10, 95, 'Customers Targetted : ')
  doc.text(70, 95, Number(singleData?.stats?.messagesSent).toLocaleString())

  doc.text(10, 105, 'Invoices Generated : ')
  doc.text(70, 105, Number(singleData?.stats?.invoices).toLocaleString())

  doc.text(10, 115, 'Revenue Generated : ')
  doc.text(70, 115, 'Rs. ' + Number(singleData?.stats?.invoiceTotal).toLocaleString())

  doc.text(10, 125, 'CCR : ')
  doc.text(70, 125, `${singleData?.stats?.conversionRate}%`)

  doc.text(10, 135, 'Average Bill Size : ')
  doc.text(
    70,
    135,
    'Rs. ' +
      Math.round(singleData?.stats?.invoiceTotal / singleData?.stats?.invoices).toLocaleString(),
  )

  doc.line(10, 145, 300, 145)
  doc.line(10, 147, 300, 147)

  doc.addPage()
  doc.setFontSize(22)
  doc.text(
    10,
    20,
    // eslint-disable-next-line
    'Customer Details ' + `( showing ${campaignDetails.length} customers )`,
  )

  doc.line(10, 30, 200, 30)
  doc.line(10, 30, 10, 45)
  doc.line(200, 30, 200, 45)
  doc.line(10, 45, 200, 45)

  doc.setFontSize(16)
  doc.text(25, 39, 'Mobile')
  doc.text(90, 39, 'Invoices')
  doc.text(160, 39, 'Amount')

  doc.setFontSize(15)
  var xAxis = 50
  // eslint-disable-next-line
  campaignDetails.map((user) => {
    if (xAxis >= 280) {
      doc.addPage()
      doc.line(10, 20, 200, 20)
      doc.line(10, 20, 10, 45)
      doc.line(200, 20, 200, 45)

      doc.line(85, 20, 85, 45)
      doc.line(140, 20, 140, 45)

      xAxis = 20
    }
    xAxis += 10

    //   // bottom Line
    doc.line(10, xAxis, 200, xAxis)
    // Left Side Line
    doc.line(10, xAxis, 10, 45)

    // Right Side Lines
    doc.line(85, 30, 85, xAxis)
    doc.line(140, 30, 140, xAxis)

    doc.line(200, 45, 200, xAxis)

    doc.text(20, xAxis - 3, user.mobile)
    doc.text(100, xAxis - 3, String(user.invoices))
    doc.text(160, xAxis - 3, 'Rs. ' + user.amount?.toLocaleString())
  })

  xAxis += 10

  doc.addPage()
  doc.setFontSize(22)
  // eslint-disable-next-line
  doc.text(10, 20, 'Shop Wise Sales ' + `( showing ${shopWise.length} shops )`)

  doc.line(10, 30, 160, 30)
  doc.line(10, 30, 10, 45)
  doc.line(160, 30, 160, 45)
  doc.line(10, 45, 160, 45)

  doc.setFontSize(16)
  doc.text(25, 39, 'Shop Name')
  doc.text(90, 39, 'Amount')

  doc.setFontSize(15)
  var newXAxis = 50
  // eslint-disable-next-line
  shopWise.map((data) => {
    if (newXAxis >= 280) {
      doc.addPage()
      doc.line(10, 20, 160, 20)
      doc.line(10, 20, 10, 45)
      // doc.line(120, 20, 120, 45);

      doc.line(85, 20, 85, 45)
      doc.line(160, 20, 160, 45)

      newXAxis = 20
    }
    newXAxis += 10

    //   // bottom Line
    doc.line(10, newXAxis, 160, newXAxis)
    // Left Side Line
    doc.line(10, newXAxis, 10, 45)

    // Right Side Lines
    doc.line(85, 30, 85, newXAxis)
    doc.line(160, 30, 160, newXAxis)

    doc.line(160, 45, 160, newXAxis)

    doc.text(20, newXAxis - 3, data.shop)
    doc.text(90, newXAxis - 3, 'Rs. ' + data.amount?.toLocaleString())
  })

  setTimeout(() => {
    doc.save(`campaign-report.pdf`)
  }, 3000)
}

export const gettokenData = () => {
  if (localStorage.getItem('token')) {
    let token = jwt_decode(localStorage.getItem('token'))

    return decrypt(token.data)
  } else {
    notification.warning({
      description: `Please login again`,
      duration: 3,
      placement: 'bottomRight',
    })
  }
}

export const contains = (target, pattern) => {
  var value = 0
  pattern.forEach(function (word) {
    value = value + target.includes(word)
  })
  return value === 1
}
export const Round = (number) => {
  return Math.round(number)
}
